import { render, staticRenderFns } from "./CourseShowBuy.vue?vue&type=template&id=a7c42f22&scoped=true"
import script from "./CourseShowBuy.vue?vue&type=script&lang=js"
export * from "./CourseShowBuy.vue?vue&type=script&lang=js"
import style0 from "./CourseShowBuy.vue?vue&type=style&index=0&id=a7c42f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c42f22",
  null
  
)

export default component.exports